import { render, staticRenderFns } from "./teaDynamic.vue?vue&type=template&id=83b82bbc&scoped=true"
import script from "./teaDynamic.vue?vue&type=script&lang=js"
export * from "./teaDynamic.vue?vue&type=script&lang=js"
import style0 from "./teaDynamic.vue?vue&type=style&index=0&id=83b82bbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b82bbc",
  null
  
)

export default component.exports